<!--
* 组件名 : 章节标题
* 开发者 : JY
*
* 参数:
*  chapTip           { String }   required - 当前章节Tip
*  chapterTitle      { String }   required - 当前章节标题
*  stageTitle        { String }   required - 当前章节时期年份
*
* 事件: null
* 
-->

<template>
  <div class="chapter-title-wrapper">
    <div class="title-content">
      <span class="chapter-label title1">{{ chapTip }}</span>
      <h1 class="chapter-title title1" v-html="chapterTitle" />
      <span class="chapter-year num" v-if="stageTitle !== ''">
        {{ stageTitle }}
      </span>
    </div>

    <div class="chapter-body d-flex" v-if="$slots.default"><slot /></div>
  </div>
</template>

<script>
export default {
  name: "v-chapter-title",
  props: {
    chapTip: {
      type: String,
      required: true,
    },
    chapterTitle: {
      type: String,
      required: true,
    },
    stageTitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
.chapter-title-wrapper {
  padding-top: 134px;
  min-height: 100vh;

  .title-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    position: relative;
    z-index: 2;
    margin: auto;
  }

  .chapter-year,
  .chapter-title {
    margin-top: 24px;
  }

  .chapter-body {
    flex-wrap: wrap;
    margin: auto;
    padding-top: 72px;
  }

  @media (max-width: $lx-min) {
    padding-top: 120px;

    .chapter-body {
      padding: 56px 0;
    }
  }
}
//  第三章首页
.the-trial-of-service-doers-wrap .page-index {
  .chapter-body {
    width: 988px;
  }
}

//  第五章首页
.period1995-1999wrap .page-index {
  .chapter-body {
    width: 1196px;
  }

  @media (min-width: $lx-max) {
    .chapter-body {
      width: 1584px;
    }
  }
}

.the-trial-of-service-doers-wrap .page-index,
.period1995-1999wrap .page-index {
  .chapter-title-wrapper {
    min-height: auto;
  }
}

body.latin {
  .chapter-title-wrapper {
    .title-content {
      max-width: 67%;
    }
  }
}
</style>
